import { AnubisGameLogic } from "../service/AnubisGameLogic.js";
import { DummySlotApi } from "../service/DummySlotApi.js";
import { RemoteSlotApi } from "../service/RemoteSlotApi.js";
import { slotDefinition } from "./slotDefinition.config.js";

export const GameServices = {
    slotApi: {
        Service: ({ services }) => {
            const isOffline = new URLSearchParams(window.location.search).has("offline");
            if (isOffline) return new DummySlotApi();

            const config = services.get("resources").get("config");
            return new RemoteSlotApi({ baseURL: config.baseURL });
        },
    },
    gameLogic: {
        Service: ({ services }) => {
            return new AnubisGameLogic({
                api: services.get("slotApi"),
                slotDefinition,
            });
        },
    },
};
